import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket: WebSocket | null = null;

  private messageSubject = new Subject<MessageEvent>();
  public connectionStatus$ = new BehaviorSubject<'connecting' | 'open' | 'closed'>('closed');

  public messages$: Observable<MessageEvent>;

  constructor() {
    this.messages$ = this.messageSubject.asObservable().pipe(shareReplay(1));
  }

  connect(url: string, token: string): Observable<MessageEvent> {
    if (this.socket?.readyState === WebSocket.OPEN || this.socket?.readyState === WebSocket.CONNECTING) {
      return this.messages$;
    }

    const fullUrl = `${url}?token=${encodeURIComponent(token)}`;
    this.socket = new WebSocket(fullUrl);
    this.connectionStatus$.next('connecting');

    let heartbeat: any;

    this.socket.onopen = () => {
      this.connectionStatus$.next('open');

      heartbeat = setInterval(() => {
        if (this.socket?.readyState === WebSocket.OPEN) {
          this.socket.send('ping');
        }
      }, 5000);
    };

    this.socket.onmessage = (event: MessageEvent) => {
      this.messageSubject.next(event);
      if (event.data === 'pong') {
      }
    };

    this.socket.onerror = (error) => {
      this.messageSubject.error(error);
    };

    this.socket.onclose = (event) => {
      if (heartbeat) clearInterval(heartbeat);
      this.connectionStatus$.next('closed');
      this.messageSubject.complete();
    };
    return this.messages$;
  }

  send(message: any): void {
    if (this.socket?.readyState === WebSocket.OPEN) {
      const payload = typeof message === 'string' ? message : JSON.stringify(message);
      this.socket.send(payload);
    } else {
      console.warn('WebSocket not open. ReadyState:', this.socket?.readyState);
    }
  }

  close(): void {
    if (this.socket) {
      this.socket.close(1000, 'Client initiated close');
      this.socket = null;
    }
  }
}